// Which admin hub pages a user can actually open, so the navigation only offers those.
//
// `routes` is the flattened list from the system store, where each page names its parent
// through `parent_id`. A page's own `permission` is a product access permission, checked
// against the networks the user is assigned to; each module's `permission` is one of the
// user's own permissions. Model pages (create and edit screens bound to a record) are never
// linked to directly, so they are left out of the decision.

function childPagesOf(route, routes) {
  return routes.filter((r) => r.parent_id === route.id && !r.modules.some((m) => m.model))
}

function hasProductAccess(route, user) {
  return !route.permission || user.admin_access_permissions_list.includes(route.permission)
}

function canSeeModules(route, user) {
  return (
    route.modules.length > 0 &&
    route.modules.every((m) => !m.permission || user.all_permissions_list.includes(m.permission))
  )
}

/**
 * A page can be opened when the user has its product, and either they can see every module
 * on it or they can open one of its child pages. A page with neither modules nor children,
 * such as an external link, is always offered.
 */
export function canOpenPage(route, routes, user) {
  if (!user || !hasProductAccess(route, user)) {
    return false
  }

  const children = childPagesOf(route, routes)
  if (route.is_external || (route.modules.length === 0 && children.length === 0)) {
    return true
  }

  return canSeeModules(route, user) || children.some((child) => canOpenPage(child, routes, user))
}

/**
 * The path segments a menu link should follow. A page that shows its children as tabs opens
 * on the first tab the user can open, rather than one that would only tell them access is
 * denied.
 */
export function landingPathOf(route, routes, user) {
  if (!route.show_tabs) {
    return [route.path]
  }

  const children = childPagesOf(route, routes)
  const next = children.find((child) => canOpenPage(child, routes, user)) ?? children[0]

  return next ? [route.path, ...landingPathOf(next, routes, user)] : [route.path]
}
